import { Subject } from "rxjs";
import { Channel, ChannelPayloadFilter } from "spyne";

export class ChannelExternalEventsLauncher extends Channel {
  constructor(name, props = {}) {
    name = "CHANNEL_EXTERNAL_EVENTS_LAUNCHER";
    props.sendCachedPayload = false;

    super(name, props);
  }

  onRegistered() {
    const modalBtnFilter = new ChannelPayloadFilter({
      payload: (p) => p.btnType === "externalEvent",
    });

    this.getChannel("CHANNEL_UI", modalBtnFilter).subscribe(
      this.onWindowEventBtnClicked.bind(this),
    );
  }

  onWindowEventBtnClicked(e) {
    const { payload, srcElement } = e;
    const { externalEvent, externalEventVal } = payload;

    this.sendChannelPayload(
      "CHANNEL_EXTERNAL_EVENTS_LAUNCHER_EVENT",
      { externalEvent, externalEventVal },
      srcElement,
    );

    //  const {openModal, modalType} = payload;

    // const isOpenModal = String(openModal) === "true";

    // this.sendChannelPayload("CHANNEL_MODAL_WINDOW_CHANGE_EVENT", {isOpenModal, openModal, modalType}, srcElement)
  }

  addRegisteredActions() {
    return ["CHANNEL_EXTERNAL_EVENTS_LAUNCHER_EVENT"];
  }

  onViewStreamInfo(obj) {
    let data = obj.props();
  }
}
